import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../App';
import { toast } from 'sonner';

const AcessoLogin = ({ setUser }) => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [empresa, setEmpresa] = useState(null);
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axiosInstance.get(`/acesso/${slug}`)
      .then(r => setEmpresa(r.data))
      .catch(() => setEmpresa({ nome: 'Empresa', slug }));
  }, [slug]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axiosInstance.post('/auth/login', {
        email: form.email.trim().toLowerCase(),
        password: form.password,
      });
      const data = response.data;
      const u = data.user || {};
      const user = {
        id: u.id || u.user_id,
        user_id: u.user_id || u.id,
        name: u.name,
        email: u.email,
        role: u.role,
        company_id: u.company_id,
        permissoes: u.permissoes || {},
        categoria: u.categoria || null,
      };
      if (data.access_token) localStorage.setItem('segcore_access_token', data.access_token);
      if (data.refresh_token) localStorage.setItem('segcore_refresh_token', data.refresh_token);
      localStorage.setItem('user', JSON.stringify(user));
      setUser(user);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      const msg = err.response?.data?.detail || 'Email ou senha incorretos.';
      toast.error(typeof msg === 'string' ? msg : 'Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950">
      <div className="w-full max-w-sm p-8 rounded-2xl bg-zinc-900 border border-zinc-800 shadow-xl">
        <h1 className="text-2xl font-bold text-white mb-1 text-center">SegCore</h1>
        {empresa && (
          <p className="text-sm text-zinc-400 text-center mb-6">{empresa.nome}</p>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs text-zinc-400 mb-1">Email</label>
            <input
              type="email"
              required
              autoComplete="username"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              className="w-full px-3 py-2 rounded-lg bg-zinc-800 border border-zinc-700 text-white text-sm focus:outline-none focus:border-purple-500"
              placeholder="seu@email.com"
            />
          </div>
          <div>
            <label className="block text-xs text-zinc-400 mb-1">Senha</label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              className="w-full px-3 py-2 rounded-lg bg-zinc-800 border border-zinc-700 text-white text-sm focus:outline-none focus:border-purple-500"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white font-semibold text-sm transition-colors disabled:opacity-50"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AcessoLogin;
